/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import FormInputs from "../FormInputs";
import useData from "../../hooks/useData";
import {updateEmailInfos} from "../../api/admin/emailReq";
import useAuth from "../../hooks/useAuth";
import {useParams} from "react-router-dom";
import EmailModalHelp from "../../components/common/admin/EmailModalHelp";
import FormButtons from "../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../helper/tools";
import Icon from "../../components/common/Icon";

export default function FormEmails({ legend, setShowModal, apiEmailInfos }) {

    const {htmlInputContent, emailInfos } = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const [ showHelpModal, setShowHelpModal ] = useState(false);
    const [ reduceEmail, setReduceEmail ] = useState(false);
    const [ values, setValues ] = useState();

    useEffect(() => {
        setValues(emailInfos)
    }, [ emailInfos ]);

    useEffect(() => {
        apiEmailInfos()
    }, [ id ]);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const handleEmailHelpModal = () => {
        setShowHelpModal(true)
        setReduceEmail(true)
    };

    useEffect(() => {
        if (reduceEmail) {
            let emailWindow = document.querySelector(".email-infos")
            emailWindow.style.position = "absolute"
            emailWindow.style.right = "0"
        }
    }, [ reduceEmail ]);


    useEffect(() => {
        const newValues = { ...values };

        for (const key in htmlInputContent) {
            if (htmlInputContent.hasOwnProperty(key)) {
                newValues[key] = htmlInputContent[key];
            }
        }
        setValues(newValues);
    }, [ htmlInputContent]);

    const handleRemoveInfosModal = () => {
        setShowModal(false)
    };

    const handleHtmlContent = (e, inputName) => {
        setValues({...values, [inputName] : e})
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(id),
            description: values?.description,
            subject: values?.subject,
            body: values?.body
        }
        return (
            await updateEmailInfos(token, body)
                .then(response => {
                    removeErrorList()
                    if (!response?.response?.data?.error) {
                        setShowModal(false)
                        apiEmailInfos()
                    } else {
                        getErrorListFromValidation(response?.response?.data?.error)
                    }
                })
        )
    }

    const inputs = [
        {
            id : 2,
            name : "description",
            type : "textarea",
            placeholder : "Description",
            label : "Description",
        },
        {
            id : 6,
            name : "subject",
            type : "text",
            placeholder : "Sujet",
            label : "Sujet",
            required : true,
        },
        {
            id : 7,
            type: "html",
            name : "body",
            placeholder : "Contenu HTML",
            label : "Contenu HTML",
            content : values?.body,
            required : true,
            className : "html-textarea",
        },
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate className="not-relative">
            <fieldset>
                { showHelpModal &&
                    <div className="modal email-help">
                        <EmailModalHelp setShowHelpModal={setShowHelpModal} legend="Informations générales"/>
                    </div>
                }
                {(legend !== "no-legend") && <Icon source="fa fa-at" span={legend}/>}
                <button type="button" className="question"><i className="fa fa-question" onClick={handleEmailHelpModal}></i></button>
                {inputs.map(input =>(
                    <FormInputs
                        type={ input.type }
                        name={ input.name }
                        id={ input.id }
                        label={input.label}
                        placeholder={ input.placeholder }
                        value={ values?.[input.name] }
                        onChange={ onChange }
                        onChangeHtml={(e) => handleHtmlContent(e,input.name)}
                        required={ input.required }
                        key={ input.id+input.name }
                        content={ input.content }
                        pattern={ input.pattern }
                    />
                ))}
                <FormButtons handleRemoveModal={handleRemoveInfosModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>

    )
}